import vmClient from 'app/services/vmClient';
import { IWord, Word } from 'app/constants/schemas/Word';
import { IVocabListWordSentence, VocabListWordSentence } from 'app/constants/schemas/VocabListWordSentence';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IVocabListWord extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    word: IWord;
    vocabListWordSentences: IVocabListWordSentence[];
  };
}

export type VocabListWord = Entity<IVocabListWord>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabListWord: IEntityType<IVocabListWord> = vmClient.defineClass({
  typeName: 'VocabListWord',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {
  },
  associations: {
    word: {
      type: Word,
      notNull: true,
      shared: true,
    },
    vocabListWordSentences: {
      type: VocabListWordSentence,
      collection: true,
      notNull: true,
    },
  },
});
